import * as React from 'react';

const UnorderedListSvg = (props: React.SVGProps<SVGSVGElement>) => (
    <svg
        id="unordered-list_svg__eds-icon--unordered-list_svg"
        x={0}
        y={0}
        viewBox="0 0 24 24"
        xmlSpace="preserve"
        {...props}
    >
        <g fillRule="evenodd" clipRule="evenodd">
            <path
                id="unordered-list_svg__eds-icon--unordered-list_dash_2_"
                d="M9 18.5h11v-1H9v1z"
            />
            <path
                id="unordered-list_svg__eds-icon--unordered-list_dash_1_"
                d="M9 11.5h11v1H9z"
            />
            <path
                id="unordered-list_svg__eds-icon--unordered-list_dash"
                d="M9 5.5h11v1H9z"
            />
        </g>
        <g fillRule="evenodd" clipRule="evenodd">
            <path
                id="unordered-list_svg__eds-icon--unordered-list_dot"
                d="M4 5.5h2v1H4z"
            />
            <path
                id="unordered-list_svg__eds-icon--unordered-list_dot_1_"
                d="M4 11.5h2v1H4z"
            />
            <path
                id="unordered-list_svg__eds-icon--unordered-list_dot_2_"
                d="M4 17.5h2v1H4z"
            />
        </g>
    </svg>
);

UnorderedListSvg.displayName = 'UnorderedListSvg';
export default UnorderedListSvg;
